<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  data(){
  return {
 
  }
  },
}
</script>

<style scoped>
	

    </style>



// WEBPACK FOOTER //
// src/App.vue